import $ from 'jquery';
import game from './game';

$(() => {
  $('.js-hero-pacman a').on('click', (e) => {
    e.preventDefault();

    $('.js-pacman-initial').hide();
    $('.js-pacman-game').show();
    $('.js-hero-pacman').css({
      backgroundImage: 'none',
    });

    setTimeout(() => {
      const $game = $('#game');
      game.init($game[0]);
      try { window.ga('send', 'event', 'Halloween', 'Init'); } catch (exeption) {}
    }, 0);

    return false;
  });
});



// WEBPACK FOOTER //
// ./_components/hero-halloween-block/index.js